@if (isVisible()) {
  <div [@slideInOut]="isVisible() ? 'in' : 'out'"
  class="fixed top-4 left-4 md:left-auto right-4 z-[99999] mx-auto md:mx-0 max-w-md">

  <!-- Backdrop overlay (optional) -->
  <div class="fixed inset-0 bg-black bg-opacity-10 -z-10" (click)="close()">
  </div>

  <!-- Snackbar content -->
  <div [ngClass]="snackbarClasses()" class="rounded-lg shadow-lg p-4 flex items-start space-x-3">
    <!-- Icon -->
    <div class="flex-shrink-0 mt-0.5">
      @if (config().type === 'error') {
        <svg  class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.804-.833-2.598 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      }
      
      @if (config().type === 'warning') {
        <svg  class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.804-.833-2.598 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      }
      @if (config().type === 'success') {
        <svg  class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      }

      @if (config().type === 'info') {
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      }
    </div>

    <!-- Message content -->
    <div class="flex-1 min-w-0">
      <div class="font-medium text-sm" [innerHTML]="config().message"></div>

      <!-- Countdown timer -->
      <div *ngIf="config().showCountdown && countdown() > 0" [ngClass]="countdownTextClasses()"
        class="text-sm mt-1 font-mono flex items-center">
        <svg class="inline h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Coba lagi dalam {{ formatTime(countdown()) }}
      </div>
    </div>

    <!-- Close button -->
    <button (click)="close()" [ngClass]="closeButtonClasses()"
      class="flex-shrink-0 hover:opacity-80 transition-opacity">
      <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</div>
}
